import { proxy } from 'valtio';

import { QUERY_PARAM_HIDE_UI } from '@canvas/constants/query-params';

/**
 * Marks whether menus are currently visible.
 */
export const currentMenuVisiblityState = proxy({
  visible: !new URLSearchParams(globalThis.location?.search).has(QUERY_PARAM_HIDE_UI),
});
